import React from 'react';
import {InvestigationsUIProvider} from "./InvestigationsUIContext";
import {InvestigationsCard} from "./InvestigationsCard";
import {Route} from "react-router-dom";
import {InvestigationDeleteDialog} from "./investigation-delete-dialog/InvestigationDeleteDialog";

export function InvestigationsPage({history}) {

    const investigationsUIEvents = {
        newInvestigationButtonClick: () => {
            history.push('/QC/investigations/new');
        },
        viewInvestigationButtonClick: (id) => {
            history.push(`/QC/investigations/${id}/view`);
        },
        deleteInvestigationButtonClick: (id) => {
            history.push(`/QC/investigations/${id}/delete`);
        }
    }


    return (
        <InvestigationsUIProvider investigationsUIEvents={investigationsUIEvents}>

            <Route path={"/QC/investigations/:id/delete"}>
                {({history, match}) => (
                    <InvestigationDeleteDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => history.push("/QC/investigations")}
                    />
                )}
            </Route>


            <InvestigationsCard/>

        </InvestigationsUIProvider>
    )

}